import { type FunctionalComponent, h } from '@stencil/core';
import type { labelProviderInterface } from '../../../../LabelProviderInterface';
import { FacetB2cViewButton } from './b2c/facet-b2c-view-button';
import {FacetDefaultViewButton} from './default/facet-default-view-button';

export interface IFacetViewButton {
  handleViewBtnClicked: Function;
  isCollapseCharacteristicsBtn?: boolean;
  showAllFacets?: boolean;
  labelProvider: labelProviderInterface;
  collapseCharactericticsBtnType?: string;
	collapsedCharacteristicsNo: number;
}

export const FacetViewButton: FunctionalComponent<
  IFacetViewButton
> = (props) => {
    const {
      handleViewBtnClicked,
      isCollapseCharacteristicsBtn,
      collapseCharactericticsBtnType,
      collapsedCharacteristicsNo,
      showAllFacets,
      labelProvider,
    } = props;

    if(!isCollapseCharacteristicsBtn || !collapseCharactericticsBtnType) return '';

    switch (collapseCharactericticsBtnType) {
    case 'b2c':
      return <FacetB2cViewButton
        handleViewBtnClicked={handleViewBtnClicked}
        showAllFacets={showAllFacets}
        labelProvider={(e, f) => labelProvider(e, f)}
      />;

    case 'default':
      return <FacetDefaultViewButton
        handleViewBtnClicked={handleViewBtnClicked}
        showAllFacets={showAllFacets}
        collapsedCharacteristicsNo={collapsedCharacteristicsNo}
        labelProvider={(e, f) => labelProvider(e, f)}
      />;
    default:
      return '';
    }
};
